import React from 'react';
import './PromotionalPosters.css';

function PromotionalPosters() {
  return (
    <div className="posters-section">
      <div className="posters-container">
        {/* Poster 1: Learn from Top Company Employees */}
        <div className="poster-card poster-companies">
          <div className="poster-content">
            <div className="poster-badge">Premium Learning</div>
            <h2 className="poster-title">Learn from Industry Experts</h2>
            <div className="companies-logos">
              <div className="company-badge google">
                <svg viewBox="0 0 24 24" className="company-icon">
                  <path fill="currentColor" d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"/>
                </svg>
                <span>Google</span>
              </div>
              <div className="company-badge microsoft">
                <svg viewBox="0 0 24 24" className="company-icon">
                  <path fill="currentColor" d="M0 0v11.408h11.408V0zm12.594 0v11.408H24V0zM0 12.594V24h11.408V12.594zm12.594 0V24H24V12.594z"/>
                </svg>
                <span>Microsoft</span>
              </div>
              <div className="company-badge amazon">
                <svg viewBox="0 0 24 24" className="company-icon">
                  <path fill="currentColor" d="M.045 18.02c.072-.116.187-.124.348-.022 3.636 2.11 7.594 3.166 11.87 3.166 2.852 0 5.668-.533 8.447-1.595l.315-.14c.138-.06.234-.1.293-.13.226-.088.39-.046.525.13.12.174.09.336-.12.48-.256.22-.975.62-2.138 1.195-1.163.574-2.388 1.008-3.675 1.302-1.287.293-2.603.44-3.948.44-2.857 0-5.582-.533-8.176-1.595-1.675-.685-3.07-1.52-4.182-2.504-.05-.045-.078-.124-.084-.234-.005-.11.015-.193.06-.25zM23.85 16.175c-.184-.307-.684-.484-1.502-.53-.818-.046-1.76.088-2.826.403-.107.033-.178.026-.21-.02-.033-.047-.02-.11.038-.188.554-.582 1.365-.87 2.435-.87.523 0 .96.084 1.312.25.352.167.53.39.53.67 0 .12-.03.22-.09.303-.06.083-.12.124-.18.124-.06 0-.09-.02-.09-.06zm-13.814-2.24c0-.673.158-1.207.474-1.604.316-.397.735-.595 1.256-.595.435 0 .803.154 1.104.463.3.31.45.72.45 1.232 0 .673-.154 1.214-.463 1.623-.31.41-.722.614-1.238.614-.44 0-.81-.155-1.112-.465-.3-.31-.45-.733-.45-1.268z"/>
                </svg>
                <span>Amazon</span>
              </div>
            </div>
            <p className="poster-description">
              Get mentored by professionals working at world's leading tech companies
            </p>
            <div className="poster-features">
              <div className="feature-item">✓ Industry Best Practices</div>
              <div className="feature-item">✓ Real-world Projects</div>
              <div className="feature-item">✓ Expert Guidance</div>
            </div>
          </div>
        </div>

        {/* Poster 2: Learn from IITians and NITians */}
        <div className="poster-card poster-institutes">
          <div className="poster-content">
            <div className="poster-badge">Elite Mentorship</div>
            <h2 className="poster-title">Learn from IITians & NITians</h2>
            <div className="institutes-badges">
              <div className="institute-badge iit">
                <div className="institute-icon">IIT</div>
                <span>IIT Alumni</span>
              </div>
              <div className="institute-badge nit">
                <div className="institute-icon">NIT</div>
                <span>NIT Alumni</span>
              </div>
            </div>
            <p className="poster-description">
              Learn from India's finest engineering minds and top-tier institute graduates
            </p>
            <div className="poster-features">
              <div className="feature-item">✓ Premier Institute Standards</div>
              <div className="feature-item">✓ Competitive Programming</div>
              <div className="feature-item">✓ Problem-Solving Skills</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PromotionalPosters;
